const state = {
  dataList: [],
  readOnly: true,
}
const getters = {
  dataList: (state) => state.dataList,
  readOnly: (state) => state.readOnly,
}

const mutations = {
  setDataList (state, list) {
    state.dataList = list
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
